import { render, staticRenderFns } from "./post-promote-addon-badges.vue?vue&type=template&id=716a6afe&"
import script from "./post-promote-addon-badges.vue?vue&type=script&lang=js&"
export * from "./post-promote-addon-badges.vue?vue&type=script&lang=js&"
import style0 from "./post-promote-addon-badges.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('716a6afe')) {
      api.createRecord('716a6afe', component.options)
    } else {
      api.reload('716a6afe', component.options)
    }
    module.hot.accept("./post-promote-addon-badges.vue?vue&type=template&id=716a6afe&", function () {
      api.rerender('716a6afe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/post/promote/post-promote-addon-badges.vue"
export default component.exports